<template>
  <div class="view-summary">
    <!-- Range display -->
    <div class="info-box title-box">
      <div>
        <i18n-t :keypath="`viewOrders.overview.filter.${filterType}`" scope="global">
          <template v-slot:from>
            <b>{{ from }}</b>
          </template>
          <template v-slot:to>
            <b>{{ to }}</b>
          </template>
        </i18n-t>
      </div>
      <button class="back-icon" v-on:click="handleBackButton" />
    </div>
    <ProductSplit :order-numbers="getOrdersNumbers" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ProductSplit from '@/components/summary/product-split.vue';
import { mappersMixins } from '@/mixins/mappers.mixins';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';

export default defineComponent({
  name: 'view-summary',
  components: {
    ProductSplit,
  },
  setup() {
    const router = useRouter();
    const { selectedAccount } = storeToRefs(useUserStore());

    return {
      loading: true,
      error: false,
      from: router.currentRoute.value.query.to,
      to: router.currentRoute.value.query.to,
      key: router.currentRoute.value.query.key,
      filterType: router.currentRoute.value.query.filterType,
      account: selectedAccount,
    };
  },
  computed: {
    getOrdersNumbers(): string[] {
      const orders = window.localStorage.getItem(`order-numbers-${this.key}`);

      if (orders) {
        return JSON.parse(orders) as string[];
      }

      return [];
    },
  },
  methods: {
    ...mappersMixins,
    handleBackButton() {
      this.$router.go(-1);
    },
  },
});
</script>

<style scoped lang="scss">
#backstage-ui .view-summary {
  @include common-container;
}
</style>
<style scoped lang="scss">
.view-summary {
  .info-box {
    padding: 20px;
    text-align: left;
    background-color: var(--primary-bg-color);
    border-radius: 8px;
    width: 100%;
    font-size: 14px;
    color: var(--primary-text-color);

    p {
      margin: 0;
    }
  }

  .info-box ~ .info-box {
    margin-left: 12px;
  }

  .title-box {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 40px;
    letter-spacing: 0em;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .back-icon {
      background-color: initial;
      background-image: url('@/assets/img/back-icon.svg');
      border: none;
      cursor: pointer;
      height: 42px;
      width: 42px;
      padding: 0;
    }
  }

  .product-split:deep() {
    .summary-box {
      margin-bottom: 30px;
    }
  }
}
</style>
